import { type ComponentProps } from 'react';
import { Text } from '@launchpad-ui/components';
import clsx from 'clsx';

export function Description(props: ComponentProps<typeof Text>) {
  return <Text {...props} slot="description" className={clsx(props.className)} />;
}
